import { NgTemplateOutlet } from "@angular/common";
import { Directive, Input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from "@angular/core";
import { isEqual } from "lodash";

@Directive({selector: "[immutableTemplateOutlet]"})
export class ImmutableTemplateOutletDirective extends NgTemplateOutlet implements OnChanges {
    @Input("immutableTemplateOutletContext") public ngTemplateOutletContext: Object;
    @Input("immutableTemplateOutlet") public ngTemplateOutlet: TemplateRef<any>;
    @Input() public stateProp;

    constructor(__viewContainerRef: ViewContainerRef) {
        super(__viewContainerRef);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (this.deepEqual(changes)) {
            return;
        } else {
            super.ngOnChanges(changes);
        }
    }

    public deepEqual(changes) {
        const context = changes.ngTemplateOutletContext;
        return isEqual(context.previousValue, context.currentValue);
    }
}
